import axios from 'axios';
import Constants, { fixProtocol } from '../../../constants/constants';

export const removePlayerFromRestorative = async (playerId: number) => {
  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/players/remove-player-from-restorative`);

  try {
    const response = await axios.post(url.toString(), { player_id: playerId });
    return response;
  } catch (e) {
    return false;
  }
};
